import React from 'react';

const InterviewTypeChoice = ({ isDark, primaryColor, onChoose, canUseAi = true, canUseManual = true }) => {
  const cardClass = `rounded-lg border p-5 text-left transition-all hover:-translate-y-0.5 hover:shadow-md ${
    isDark ? 'bg-gray-700 border-gray-600 hover:border-indigo-400' : 'bg-white border-gray-200 hover:border-indigo-300'
  }`;

  return (
    <div className="space-y-4">
      <div className={`rounded-lg p-4 ${isDark ? 'bg-gray-700' : 'bg-gray-50'}`}>
        <h3 className={`text-base font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>Choose interview path</h3>
        <p className={`mt-1 text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
          Pick the setup for this job. The choice is saved once and reused for future scheduling.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {canUseAi && (
          <button type="button" onClick={() => onChoose('ai')} className={cardClass}>
            <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg text-white" style={{ backgroundColor: primaryColor }}>
              AI
            </div>
            <h4 className={`text-sm font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>AI Interview</h4>
            <p className={`mt-2 text-xs leading-5 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
              Select an interview configuration, create reusable AI slots, and send candidates a secure timed interview link.
            </p>
          </button>
        )}

        {canUseManual && (
          <button type="button" onClick={() => onChoose('manual')} className={cardClass}>
            <div className={`mb-3 flex h-10 w-10 items-center justify-center rounded-lg ${isDark ? 'bg-gray-600 text-gray-100' : 'bg-gray-100 text-gray-700'}`}>
              M
            </div>
            <h4 className={`text-sm font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>Manual Interview</h4>
            <p className={`mt-2 text-xs leading-5 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
              Continue with interviewer selection, Google Meet booking, calendar event creation, and the existing candidate slot flow.
            </p>
          </button>
        )}
      </div>
    </div>
  );
};

export default InterviewTypeChoice;
